import { IGlobalState } from '../../../Root/store/appReducer'

export const getUserNotificationsList = (state: IGlobalState) => state.inbox.list
export const getUserNotificationsLoading = (state: IGlobalState) => state.inbox.isLoading
